import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { LoginRequest } from 'src/app/features/login/login-request.model';
import { LoginOtpRequest } from 'src/app/features/login/otp-request.model';
import { environment } from 'src/environment';
import { APP_AUTH_CONFIG } from 'src/app/features/login/auth.tokens';
import { LoginMethod } from 'src/app/features/login/auth.types';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  #httpservice = inject(HttpClient);
  #baseUrl = environment.apiUrl;
  #specificUrl = `${this.#baseUrl}/auth`;
  #authConfig = inject(APP_AUTH_CONFIG);
  logOut = () => { return this.#httpservice.get(`${this.#specificUrl}/logOut`); }

  checkLoginWithSecondAppAsIDP = () => {
    return this.#httpservice.post<{ guid: string }>(`${environment.IDPAppUrl}/connection`, {})
  };

  loginWithGuid = (guid: string) => {
    return this.#httpservice.post<{ token: string }>(`${this.#specificUrl}/loginidp`, { userGuid: guid });
  }

  login = (request: object, loginMethod?: LoginMethod) => {
    const endpoint = loginMethod && this.#authConfig.endpoints?.[loginMethod]
      ? this.#authConfig.endpoints[loginMethod]
      : 'loginAuth';
    return this.#httpservice.post<{ token: string }>(`${this.#specificUrl}/${endpoint}`, request);
  }

  refreshToken = () => { return this.#httpservice.get<{ token: string }>(`${this.#specificUrl}/refreshToken`); }
  refreshTokenIDP = () => { return this.#httpservice.get<{ token: string }>(`${environment.IDPAppUrl}/user-info`); }

  sendOtp = (request: LoginOtpRequest) => {
    return this.#httpservice.post<{ success: boolean }>(`${this.#specificUrl}/sendOtp`, request);
  }

}
